import {  useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form, message} from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import {  SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker


const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 12 }
}

interface ep {
    "employee_id": string,
    "user_name": string
}
type fetchParams = {
    look_after_type:undefined|number,
    store_id: undefined | string,
    look_after_id: undefined| string,
    room_type_id: undefined | string,
    check_in_phone: undefined | string,
    check_in_user_name: undefined | string,
    handle_status: number|undefined,
    complaint_department_id: string | undefined,
    room_number: string | undefined,
    inDate: any
    outDate: any
    handleDate:any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type department = {
    "room_type_id": string,
    "room_type_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        outDate: null,
        look_after_type:undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        room_type_id:undefined,
        look_after_id:undefined,
        store_id: undefined ,
        handle_status: undefined,
        complaint_department_id:  undefined,
        room_number: undefined,
        inDate: null,
        handleDate:null
    }


    const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string } | undefined>()
    const [form] = Form.useForm()

    const [recordInVisible, setRecordInVisible] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [data, setData] = useState<any>([])
    const [bmData,setBmData] = useState<department[]>([])
    const [handleNameData,setHandleNameData] = useState<any[]>([])
    const [recordInBmData,setRecordInBmData] = useState<department[]>([])
    const [loading,setLoading] = useState<boolean>(false)

    const permission: string[] = useMemo(() => {
        console.log(getPermission())
        return getPermission()
    }, [window.location.pathname])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }
    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        
        let params: any = { ...fetchOtherParams }
        
        handleDate(params, 'inDate', ['on_single_start_day', 'on_single_end_day'])
        handleDate(params, 'outDate', ['down_single_start_day', 'down_single_end_day'])

        axiosTable.get('/nursing/look_after_single/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
            setLoading(false)
        })
    }

    const handleSearch = () => {
        
        const p = { ...pagination }
        p.current = 1
        fetch({ pagination: p, fetchOtherParams })
    }


    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    type project = {
        id: string
        item_name: string
    }
    const [selectNameData,setSelectNameData] = useState<project[]>([])
    let bmOptions = bmData.map((el:any)=>(<Option value={el.room_type_id} key={el.room_type_id}>{el.room_type_name}</Option>)) 
    let ItemNameOptions = selectNameData.map((el:any)=>(<Option value={el.id} key={el.id}>{el.item_name}</Option>)) 
    const [gjData,setGjData] = useState<ep[]>([])
    
    const exportExcel = ()=>{
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        delete iPagination.showSizeChanger
        
        let params: any = { ...fetchOtherParams }
        
        handleDate(params, 'inDate', ['on_single_start_day', 'on_single_end_day'])
        handleDate(params, 'outDate', ['down_single_start_day', 'down_single_end_day'])

        baseAxiosComplete('/nursing/look_after_single/export',{params:{
            ...iPagination,
            ...params
        }}).then(res=>{
            if(res.status===0){
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        <BreadCrumb position={['护理中心', '护理师上单表']} />
        <div className="common-top-form">
            <div className="clear">
                <div className="fl" style={{ marginRight:12,marginBottom:12 }}><SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => { 
                    handleChange(v, 'store_id') 
                    // 查询护士列表
                    baseAxiosNoInfo('/global/employee_list_by_position',{params:{
                        department_id:v,
                        position_number:'35'
                    }}).then((res:any)=>{
                        res && setGjData(res)
                    })
                }} /></div>
                <Input className="fl"  style={{ width: '120px',marginRight:12,marginBottom:12 }} placeholder="护理师手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <Select allowClear className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="员工类型" value={fetchOtherParams.look_after_type} onChange={(v: number) => { handleChange(v, 'look_after_type') }}>
                    <Option value={1} key={1}>内部员工</Option>
                    <Option value={2} key={2}>合作商员工</Option>
                </Select>
                
                <Select  className="fl"  virtual={false} style={{ width:'190px',marginRight:12,marginBottom:12 }} placeholder="护理师（先选门店）"  onChange={(e: string) => { handleChange(e, 'look_after_id') }} value={fetchOtherParams.look_after_id}>
                        {gjData.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                </Select>

                <RangePicker style={{marginRight:12,marginBottom:12 }} className="fl"  placeholder={["上单开始日期", "上单结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
                <RangePicker style={{marginRight:12,marginBottom:12 }} className="fl"  placeholder={["下单开始日期", "下单结束日期"]} value={fetchOtherParams.outDate} onChange={(v: any) => { handleChange(v, 'outDate') }} />
                
                {permission.includes('查询') && <Button style={{marginRight:12,marginBottom:12 }}   className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button className="fl" style={{marginRight:12,marginBottom:12 }}  onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button className="fl"  onClick={()=>{exportExcel()}} type="dashed" >导出</Button>}
            </div>
        </div>
        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{x:'max-content'}} bordered={true}  pagination={pagination} onChange={handleTableChange}>
                <Column title="门店"  dataIndex="store_name" key="store_name" />
                <Column title="护理师"  dataIndex="look_after_name" key="look_after_name" />
                <Column title="护理师手机号码"  dataIndex="look_after_phone" key="look_after_phone" />
                <Column title="员工类型"  dataIndex="look_after_type" key="look_after_type" render={(v:number)=> v===1? <p>内部员工</p> : <p>合作商员工</p> } />
                <Column title="入住人"  dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="在住房间号"  dataIndex="check_in_room" key="check_in_room" />
                <Column title="入住状态描述"  dataIndex="check_in_status_desc" key="check_in_status_desc" /> 
                <Column   title="入住时间" dataIndex="check_in_time" key="check_in_time" />
                <Column   title="出所时间" dataIndex="check_out_time" key="check_out_time" />
                <Column   title="预住天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column   title="已住天数" dataIndex="check_in_already_days" key="check_in_already_days" />
                <Column   title="剩余天数" dataIndex="check_in_left_days" key="check_in_left_days" />
                <Column   title="上单时间" dataIndex="on_single_time" key="on_single_time" />
                <Column   title="下单时间" dataIndex="down_single_time" key="down_single_time" />
                <Column   title="上单签到天数" dataIndex="on_single_sign_day" key="on_single_sign_day" />
                <Column   title="提前下单原因" dataIndex="advance_reason" key="advance_reason" />
            </Table>
        </div>

    </div>)
}